import React from 'react';
import { Calendar } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';
import { useClientOwner } from '../../../../hooks/useClientOwner';

interface CrashCourseShape {
  meeting_link?: string;
  completed?: boolean;
  auto_populated_at?: string;
  completed_at?: string;
}

interface StrategyCallStatusBannerProps {
  organization: {
    onboardingData?: { crash_course?: CrashCourseShape; crashCourse?: CrashCourseShape };
  } | null;
}

export const CrashCourseStatusBanner: React.FC<StrategyCallStatusBannerProps> = ({
  organization,
}) => {
  const owner = useClientOwner();
  // Canonical shape: snake_case. Accept legacy camelCase `crashCourse` from
  // old Firestore onboarding so legacy orgs see correct status.
  const strategyCallData =
    organization?.onboardingData?.crash_course ?? organization?.onboardingData?.crashCourse;
  // meeting_link gates banner visibility (admin "scheduled the call").
  // The actual destination follows the org's assigned client owner so the
  // link doesn't get stuck on a previous owner's HubSpot URL after a reassign.
  const hasScheduled = Boolean(strategyCallData?.meeting_link);
  if (!hasScheduled) return null;
  if (strategyCallData?.completed === true) return null;

  return (
    <OnboardingStatusBanner
      icon={Calendar}
      title="Schedule Your Strategy Call!"
      variant="teal"
    >
      <p className="text-xs">
        Ready to maximize your results with Speculo? Schedule a strategy call with{' '}
        {owner.displayName} ({owner.role}) to optimize your setup and get personalized tips!{' '}
        <a
          href={owner.strategyMeetingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold underline hover:no-underline"
        >
          Schedule Now →
        </a>
      </p>
    </OnboardingStatusBanner>
  );
};
